import { Cookies } from 'react-cookie-consent'
import { COOKIE_EXPIRATION, API, CONSENT_COOKIE, ANALYTICS_COOKIE, CONSENT_VERSION_COOKIE, CONSENT_VERSION } from '../config'

const TRACK_ID = 'APTrackId'
const TRACK_SESSION = 'APTrackSession'
const SESSION_MINUTES = 30
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function generateUuid() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID()
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}

function isValidUuid(value) {
    return typeof value === 'string' && UUID_RE.test(value)
}

export function markConsentVersion() {
    Cookies.set(CONSENT_VERSION_COOKIE, CONSENT_VERSION, { expires: COOKIE_EXPIRATION })
}

export function migrateConsentVersion() {
    if (Cookies.get(CONSENT_VERSION_COOKIE) === CONSENT_VERSION) return
    Cookies.remove(CONSENT_COOKIE)
    Cookies.remove(ANALYTICS_COOKIE)
    Cookies.remove(TRACK_ID)
    Cookies.remove(TRACK_SESSION)
}

export function hasAnalyticsConsent() {
    return String(Cookies.get(ANALYTICS_COOKIE)) === 'true'
}

export function getClientId() {
    if (!hasAnalyticsConsent()) return null
    return Cookies.get(TRACK_ID) || null
}

export function getSessionId() {
    if (!hasAnalyticsConsent()) return null
    return Cookies.get(TRACK_SESSION) || null
}

function createTrackId() {
    Cookies.set(TRACK_ID, generateUuid(), { expires: COOKIE_EXPIRATION })
}

function createSession() {
    Cookies.set(TRACK_SESSION, generateUuid(), { expires: SESSION_MINUTES / (24 * 60) })
}

export function refreshSession() {
    if (!hasAnalyticsConsent()) return null
    let session = Cookies.get(TRACK_SESSION)
    if (!isValidUuid(session)) {
        session = generateUuid()
    }
    Cookies.set(TRACK_SESSION, session, { expires: SESSION_MINUTES / (24 * 60) })
    return session
}

export function ensureTrackingCookies() {
    if (!hasAnalyticsConsent()) return
    if (!isValidUuid(Cookies.get(TRACK_ID))) createTrackId()
    if (!isValidUuid(Cookies.get(TRACK_SESSION))) createSession()
}

export function grantAnalyticsConsent() {
    Cookies.set(CONSENT_COOKIE, 'true', { expires: COOKIE_EXPIRATION })
    Cookies.set(ANALYTICS_COOKIE, 'true', { expires: COOKIE_EXPIRATION })
    markConsentVersion()
    createTrackId()
    createSession()
}

export function declineAnalyticsConsent() {
    Cookies.set(CONSENT_COOKIE, 'true', { expires: COOKIE_EXPIRATION })
    Cookies.remove(ANALYTICS_COOKIE)
    Cookies.remove(TRACK_ID)
    Cookies.remove(TRACK_SESSION)
    markConsentVersion()
}

export function revokeAnalyticsConsent() {
    const clientId = Cookies.get(TRACK_ID)

    if (clientId) {
        try {
            fetch(API.TRACKING_REVOKE, { method: 'POST', credentials: 'include' })
        } catch (e) {}
    }

    Cookies.remove(TRACK_ID)
    Cookies.remove(TRACK_SESSION)
    Cookies.remove(ANALYTICS_COOKIE)
}
